import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { axiosInstance } from './axiosInstance';
import { FeaturesResponse } from '../interfaces/features';

const fetchFeatures = async (): Promise<FeaturesResponse> => {
  const { data } = await axiosInstance.get(`users/features`);
  return data;
};

export const useGetFeaturesQuery = (): UseQueryResult<
  FeaturesResponse,
  unknown
> =>
  useQuery({
    queryKey: ['features'],
    queryFn: fetchFeatures,
    refetchOnWindowFocus: false,
  });
